import Debug from '@/util/debug';
import FullInfoBox from '@/components/full-info-box/FullInfoBox.vue';
import SendEmail from '@/components/send-email/SendEmail.vue';
import DuplicateDraft from '@/components/duplicate-draft/DuplicateDraft.vue';
import EditCampaign from '@/components/edit-campaign/EditCampaign.vue';
import parseError, { ERROR_MODEL_NOT_FOUND } from '@/util/parse-error';
import NotFound from '@/components/not-found/NotFound.vue';
import Loading from '@/components/loading/Loading.vue';

const debug = Debug('proposal');

export default {
  dependencies: ['draftService', 'genericConfigService'],
  components: {
    EditCampaign,
    'full-info-box': FullInfoBox,
    'send-email': SendEmail,
    'duplicate-draft': DuplicateDraft,
    'not-found': NotFound,
    loading: Loading,
  },
  data() {
    return {
      loading: true,
      error: null,
      campaign: null,
      send_campaign_summary: null,
      feature_duplicate_draft: null,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    Promise.all([
      this.genericConfigService.getConfig().then(c => {
        this.send_campaign_summary = c.send_campaign_summary;
        this.feature_duplicate_draft = c.feature_duplicate_draft;
      }),
    ]);
  },
  computed: {
    campaignSummary: function computeCampaignSummary() {
      const data = {};
      data[this.$t('generic.campaign-code')] = this.campaign.code;
      data[this.$t('generic.creator')] = null;

      return data;
    },
    notFound() {
      return this.error && this.error.indexOf(ERROR_MODEL_NOT_FOUND) !== -1;
    },
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      const fin = () => {
        debug.info('finished loading. error: %o', this.error);
        this.loading = false;
      };

      this.error = null;
      this.loading = true;

      this.draftService.getById(this.$route.params.id, true, true)
        .then(a => this.campaign = a)
        .then(fin)
        .catch(err => {
          this.error = parseError(err);
          fin();
        });
    },
    sendEmail(campaign) {
      debug.info(campaign); // TODO send campaign email
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/proposal/Proposal.js